import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import {
	Header,
	RootContainer,
	SideBar,
	SideBarContainer,
} from '../LayoutClient/container.styles'
import ReactCountryFlag from "react-country-flag"
// Assets & Components
import Logo from '../../../src/assets/img/FullLogo_Transparent.png'
import MenuItems from '../LayoutClient/menu-item.component'
import ChatSupportWidget from '../ChatSupportWidget/ChatSupportWidget'
import Footer from '../Footer/footer.component'
import { BASE_URL } from '../../api/base'
import { logoutAction } from '../../redux/auth'
import { logout } from '../../api/auth'
import { MenuItem, Menu } from '@mui/material'

import {
	FaTruck, // For 'Mes transports'
	FaGlobe, // For 'Plate-forme'
	FaCalendarAlt, // For 'Historique'
	FaIdCard, // For 'Mes chauffeurs'
	FaUserCircle, // For 'Mon compte'
} from 'react-icons/fa'
import {
	IoStatsChart, // For 'Statistiques'
	IoLogOutOutline, // For 'Déconnexion'
} from 'react-icons/io5'
import { MdCancel } from 'react-icons/md' // For 'Annulées'
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from 'react-i18next'

// Default User Logo URL
const DEFAULT_USER_LOGO =
	'https://secure.gravatar.com/avatar/6ee7af2da22737fd49ce56adc226d2cb?size=200&d=mp'

function LayoutTransporter({ children }) {
	const history = useHistory()
	const dispatch = useDispatch()
	const user = useSelector((state) => state.auth.user)
	const token = useSelector((state) => state.auth.token)
	const refreshToken = useSelector((state) => state.auth.refreshToken)
	const [activeMenuItem, setActiveMenuItem] = useState(null)

	// Construct user logo URL safely
	const userLogoUrl = user?.logo?.path
		? `${BASE_URL}/${user.logo.path}`
		: DEFAULT_USER_LOGO

	// Effect to update active menu item based on path
	useEffect(() => {
		const path = history.location.pathname
		let menuItem = null

		switch (true) {
			case path.includes('/transports'):
				menuItem = 'transports'
				break
			case path.includes('/plateforme'):
				menuItem = 'plateforme'
				break
			case path === '/historique/transporter':
				menuItem = 'historique'
				break
			case path === '/annulées/transporter':
				menuItem = 'annulees'
				break
			case path === '/stats/transporter':
				menuItem = 'statistiques'
				break
			case path.includes('/chauffeurs'):
				menuItem = 'chauffeurs'
				break
			case path === '/transporter/account':
				menuItem = 'mon-compte'
				break
			default:
				menuItem = null
		}

		setActiveMenuItem(menuItem)
	}, [history.location.pathname])

	const handleLogout = async () => {
		try {
			const data = {
				userId: user?._id, // Check if user exists
				refreshToken,
			}
			if (data.userId && refreshToken) {
				// Ensure data is valid before API call
				await logout(data, token)
			}
			dispatch(logoutAction())
			history.push('/login')
		} catch (error) {
			console.error('Logout error:', error)
			// Still attempt local logout even if API fails
			dispatch(logoutAction())
			history.push('/login')
		}
	}

	// Style constants for icons
	const iconSize = 20
	const iconColor = '#f5f6f7' // Original light grey/off-white
	const whiteIconColor = 'white' // For icons that were explicitly white
	const logoutIconColor = '#e4eaf0' // Specific color from logout SVG stroke

	const savedLanguage = localStorage.getItem('language') ? localStorage.getItem('language') : 'FR';
	const [selectedItem, setSelectedItem] = useState(savedLanguage === 'FR' ? 1 : 2)
	const { i18n } = useTranslation();
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const handleMenuOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleLanguageMenuItemClick = (event, value) => {
		var language = value === 1 ? "FR" : "EN"
		event.stopPropagation();
		setSelectedItem(value);
		localStorage.setItem('language', language);
		i18n.changeLanguage(language.toLowerCase());
		setAnchorEl(null);

	};
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
	const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);


	useEffect(() => {
		const checkIfMobile = () => {
			setIsMobile(window.innerWidth < 768);
		};
		window.addEventListener('resize', checkIfMobile);

		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);

	useEffect(() => {
		if (isMobileMenuOpen && isMobile) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'unset';
		}
	}, [isMobileMenuOpen, isMobile]);

	const toggleMobileMenu = () => {
		setIsMobileMenuOpen(!isMobileMenuOpen);
	};
	const handleMenuItemClick = (originalOnClick) => {
		return () => {
			if (originalOnClick) originalOnClick();
			if (isMobile) setIsMobileMenuOpen(false);
		};
	};
	const { t } = useTranslation();
	return (
		<RootContainer>
			<Header>
				<div style={{ display: 'flex', alignItems: 'center' }}>

					{isMobile && (
						<button
							onClick={toggleMobileMenu}
							style={{
								background: 'none',
								border: 'none',
								cursor: 'pointer',
								padding: '0.5rem',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								marginRight: '1rem',
								color : "white" 
							}}
						>
							<MenuIcon size={24} />
						</button>
					)}

					{!isMobile && <img
						style={{
							width: isMobile ? '8rem' : '12rem',
						}}
						alt="logo"
						src={Logo}
					/>}
				</div>

				<div
					style={{
						background: isMobile ? 'transparent' : '#50F5A9',
						paddingRight: isMobile ? '1rem' : '2rem',
						paddingLeft: isMobile ? '1rem' : '2rem',
						paddingTop: '0.5rem',
						paddingBottom: '0.5rem',
						borderRadius: '0.9rem',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-evenly',
						fontFamily: 'Montserrat',
						color: '#fff',
						fontWeight: 'bold',
						fontSize: '1rem',
						gap: '10px',
						//textTransform: 'uppercase'
					}}
				>
					<span>
						{isMobile ? '' : t("welcome")}
						{user && ( // Simplified conditional rendering
							<>
								{user.first_name} {user.last_name}
							</>
						)}
					</span>


					<img
						style={{
							width: '2rem',
							height: '2rem',
							borderRadius: '50%', // Perfect circle
							objectFit: 'cover', // Ensure image covers area
						}}
						alt='user'
						src={userLogoUrl}
						onError={(e) => {
							e.target.src = DEFAULT_USER_LOGO
						}} // Fallback image on error
					/>
				</div>

			</Header>
			<div
				style={{
					// Removed background: 'red'
					height: 'calc(100vh - 7rem)', // Adjust if Header height changes
					width: '100%',
					display: 'flex',
					flexDirection: 'row',
					overflow: 'hidden', // Prevent outer div scrolling
				}}
			>
				{/* Mobile Overlay */}
				{isMobile && isMobileMenuOpen && (
					<div
						onClick={toggleMobileMenu}
						style={{
							position: 'fixed',
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							background: 'rgba(0, 0, 0, 0.5)',
							zIndex: 998,
						}}
					/>
				)}
				<div
					style={{
						position: isMobile ? 'fixed' : 'relative',
						left: isMobile ? (isMobileMenuOpen ? 0 : '-100%') : 0,
						top: isMobile ? 0 : 'auto',
						height: isMobile ? '100vh' : 'auto',
						transition: 'left 0.3s ease-in-out',
						zIndex: 999,
						width: isMobile ? '280px' : 'auto',
						overflowY: 'auto',
					}}
				>
					<SideBar>
						<SideBarContainer>
							<MenuItems
								title={t("my_transports")}
								active={activeMenuItem === 'transports'}
								onClick={handleMenuItemClick(() => history.push('/transports'))}
								icon={
									<FaTruck
										size={iconSize}
										color={whiteIconColor}
									/>
								}
							/>

							<MenuItems
								title={t("platform")}
								active={activeMenuItem === 'plateforme'}
								onClick={handleMenuItemClick(() => history.push('/plateforme'))}
								icon={<FaGlobe size={iconSize} color={iconColor} />}
							/>

							<MenuItems
								title={t("history")}
								active={activeMenuItem === 'historique'}
								onClick={handleMenuItemClick(() => history.push('/historique/transporter'))}
								icon={
									<FaCalendarAlt
										size={iconSize}
										color={iconColor}
									/>
								} // --- Replaced SVG ---
							/>

							<MenuItems
								title={t("cancelled_p")}
								active={activeMenuItem === 'annulees'}
								onClick={handleMenuItemClick(() => history.push('/annulées/transporter'))}
								icon={
									<MdCancel
										size={iconSize}
										color={whiteIconColor}
									/>
								} // --- Replaced SVG ---
							/>

							<MenuItems
								title={t("statistics")} // Removed extra spaces
								active={activeMenuItem === 'statistiques'}
								onClick={handleMenuItemClick(() => history.push('/stats/transporter'))}
								icon={
									<IoStatsChart
										size={iconSize}
										color={iconColor}
									/>
								} // --- Replaced SVG ---
							/>

							<MenuItems
								title={t("my_drivers")}
								active={activeMenuItem === 'chauffeurs'}
								onClick={handleMenuItemClick(() => history.push('/chauffeurs'))}
								icon={
									<FaIdCard size={iconSize} color={iconColor} />
								} // --- Replaced SVG ---
							/>

							<MenuItems
								title={t("my_account")}
								active={activeMenuItem === 'mon-compte'}
								onClick={handleMenuItemClick(() => history.push('/transporter/account'))}
								icon={
									<FaUserCircle
										size={iconSize}
										color={iconColor}
									/>
								} // --- Replaced SVG ---
							/>

							

							<div className='menu-item-container'>
								<div
									className='menu-item'
									onClick={handleMenuOpen}
									id="language-button"
									aria-controls={open ? 'language-menu' : undefined}
									aria-haspopup="true"
									aria-expanded={open ? 'true' : undefined}
								>
									<div className='icon-container'>
										<ReactCountryFlag
											countryCode={selectedItem === 1 ? "FR" : "US"}
											svg
											style={{ width: '24px', height: '24px' }}
										/>
									</div>
									<span className='menu-title'>
										{selectedItem === 1 ? "Français" : "English"}
									</span>
								</div>
							</div>

							<Menu
								id="language-menu"
								anchorEl={anchorEl}
								open={open}
								onClose={handleMenuClose}
								slotProps={{
									list: {
										'aria-labelledby': 'language-button',
									},
								}}
							>
								<MenuItem
									onClick={(event) => handleLanguageMenuItemClick(event, 1)}
									style={{ display: 'flex', gap: 8 }}
								>
									<ReactCountryFlag countryCode="FR" svg />
									Français
								</MenuItem>
								<MenuItem
									onClick={(event) => handleLanguageMenuItemClick(event, 2)}
									style={{ display: 'flex', gap: 8 }}
								>
									<ReactCountryFlag countryCode="US" svg />
									English
								</MenuItem>
							</Menu>
							<MenuItems
								onClick={handleMenuItemClick(handleLogout)}
								title={t("logout")}
								// No active state for logout
								icon={
									<IoLogOutOutline
										size={iconSize}
										color={logoutIconColor}
									/>
								} // --- Replaced SVG ---
							/>
							

						</SideBarContainer>
					</SideBar>
				</div>
				{/* Main Content Area */}
				<div
					style={{
						width: '100%',
						height: '100%', // Fill the container div
						background: 'white',
						position: 'relative', // For overlay positioning
						overflowY:
							user?.status === 'suspendu' ? 'hidden' : 'auto', // Check user exists
					}}
				>
					{children}

					{/* Suspended Account Overlay - Copied from previous example, adjust text if needed */}
					{user?.status === 'suspendu' && ( // Check user exists
						<div
							style={{
								position: 'absolute',
								inset: 0, // Covers the entire parent div
								background: 'rgba(0, 0, 0, 0.6)', // Darker overlay
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								zIndex: 10, // Ensure overlay is on top
								padding: '1rem', // Add padding for smaller screens
							}}
						>
							<div
								style={{
									width: 'clamp(300px, 50%, 600px)', // Responsive width
									background: 'white',
									borderRadius: '8px', // Slightly rounded corners
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									justifyContent: 'center',
									padding: '2rem',
									textAlign: 'center',
									boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)', // Add shadow for depth
								}}
							>
								<h2 // Use heading for semantic importance
									style={{
										fontFamily: 'Montserrat, sans-serif',
										fontSize: '1.5rem', // Relative unit
										marginBottom: '1.5rem', // More space
										color: '#dc3545', // Red color for warning
									}}
								>
									{t("suspended_account")}
								</h2>
								<p // Use paragraph for text content
									style={{
										fontFamily: 'Montserrat, sans-serif',
										fontSize: '1rem', // Relative unit
										lineHeight: 1.6, // Improve readability
									}}
								>
									{t("suspended_account_msg")}
								</p>
							</div>
						</div>
					)}
				</div>
			</div>
			<ChatSupportWidget />
			<Footer />
		</RootContainer>
	)
}

export default LayoutTransporter
